import { useDispatch } from "react-redux";
import { OfflinePrefetchProps } from "../interface";
import {
  usePrefetchUtils,
  executePaginatedPrefetch,
} from "../utils/usePrefetchUtils";
import { useCallback } from "react";
import { useLazyGetCurrentMedicationsQuery } from "app/services/api/medicationsApi";
import { storeActiveMedications } from "app/store/slices/medications";
import { store } from "app/services/store";
import { MedicationIndexPaginatedResponse } from "app/services/api/types/medications/responses/MedicationIndexResponse";
export function usePrefetchMedicationsActive({
  enabled,
}: OfflinePrefetchProps) {
  const dispatch = useDispatch();
  const [trigger] = useLazyGetCurrentMedicationsQuery();

  const handlePrefetch = useCallback(async () => {
    await executePaginatedPrefetch({
      name: "MedicationsActive",
      trigger,
      buildQueryArgs: (page) => ({
        limit: 100,
        page,
      }),
      storeData: (data) => dispatch(storeActiveMedications(data)),
      getLastPage: (data) => (data as MedicationIndexPaginatedResponse)?.meta?.last_page ?? 1,
      enableSmartCache: true,
      getFirstRecordId: (data) => (data as MedicationIndexPaginatedResponse)?.data?.[0]?.id ?? null,
      dispatch,
      getState: () => store.getState(),
    });
  }, [trigger, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
